import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import template from '../template/uiBlocker.pug';

export default class UiBlockerView extends Backbone.View {
  /**
   * Create uiblocker element to block target element.
   * @param {Object} options - render view options, contains:
   * @param {Object} options.$target - target element you want to block, DOM element.
   * @param {string} options.loadingText - loading text you want to show on ui blocker.
   * @param {boolean} options.shouldFocus - if the uiBlocker should take focus or not.
   * @param {string} options.overlayZIndex - z-index of uiBlocker to show on top of the element.
   * @returns {undefined} - no return.
 */
  initialize({
    $target, loadingText, shouldFocus, overlayZIndex,
  }) {
    this.$target = $target;
    this.loadingText = loadingText;
    this.shouldFocus = shouldFocus;
    this.overlayZIndex = overlayZIndex;
  }

  /**
   * Check whether the target is still in DOM tree.
   * @return {bool} - true if target element is still existing.
   */
  isExisting() {
    return document.documentElement.contains(this.$target);
  }

  /**
   * Set uiblocker element's css.
   * @return {undefined} - no return.
   */
  positionOverlay() {
    if (!this.$el.hasClass('blocker')) {
      this.$el.addClass('blocker');
    }

    if (this.$target === document.documentElement) {
      this.$el.css(_.extend({
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
      }));
    } else {
      const target = $(this.$target);
      // Do not show UI blocker when target element is not visible
      // Otherwise the UI blocker would be placed incorrectly on top left of the page
      // since target.offset() returns {top: 0, left: 0}
      if (target.is(':visible') && target.css('visibility') === 'visible') {
        this.$el.show();

        const updatedCss = _.extend({
          position: 'absolute',
          width: target.outerWidth(),
          height: target.outerHeight(),
          display: 'block',
        }, _.pick(target.offset(), 'left', 'top'), this.overlayZIndex === 'auto' ? null : { zIndex: this.overlayZIndex });

        if (JSON.stringify(this.currentCSS) !== JSON.stringify(updatedCss)) {
          this.currentCSS = updatedCss;

          this.$el.css(this.currentCSS);
        }
      } else {
        this.$el.hide();
      }
    }
  }

  /**
   * Render the blocker instance.
   * @return {Object} - blocker view object.
   */
  render() {
    this.$el.html(template({
      loadingText: this.loadingText,
    }));

    this.positionOverlay();

    return this;
  }

  /**
   * Remove blocker view.
   * @return {undefined} - no return.
   */
  remove() {
    super.remove();
  }
}
